<template>
  <TextInputMultiline
    v-model="descriptionCopy"
    :rows="6"
    :read-only="isTournamentFieldDisabled('description')"
    :disabled="isTournamentFieldDisabled('description')"
    :maxlength="500"
    fixed
    has-counter
    :label="$$t('Full description:', 'full-description-label')"
    :placeholder="$$t('Description', 'description-placeholder')"
    @change="val => (description = val)"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInputMultiline from '@/components/molecules/form/TextInputMultiline';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentDescriptionSetting',
  inject: ['$validator'],
  components: {
    TextInputMultiline,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      descriptionCopy: '',
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    description: {
      get() {
        return (
          this.$lodash.get(this.currentTournament, 'info.description') || ''
        );
      },
      set(newVal) {
        this.updateCurrentTournament({
          description: newVal,
          component: 'info',
        });
      },
    },
  },
  watch: {
    'currentTournament.id'() {
      this.initDescription();
    },
    'currentTournament.info.game'() {
      this.initDescription();
    },
  },
  created() {
    if (this.$route.params.tournamentID) {
      this.initDescription();
    }
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    initDescription() {
      this.descriptionCopy = this.description;
    },
  },
};
</script>
